var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ConditionService = /** @class */ (function (_super) {
            __extends(ConditionService, _super);
            function ConditionService(injectedBreeze, $q, $http) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                return _this;
            }
            ConditionService.prototype.getAllConditions = function (processConfigId) {
                var query = this.breezeModule.EntityQuery
                    .from("Conditions")
                    .where('processConfiguration_id', '==', processConfigId)
                    .orderBy("name");
                return this.executeQuery(query);
            };
            ConditionService.prototype.getAllConditionsEagerLoadExpression = function (processConfigurationId) {
                var query = this.breezeModule.EntityQuery
                    .from("Conditions")
                    .where('processConfiguration_id', '==', processConfigurationId)
                    .expand('expression')
                    .orderBy("name");
                return this.executeQuery(query);
            };
            ConditionService.prototype.getCondition = function (id) {
                return this.fetchById(id, "Condition");
            };
            ConditionService.prototype.createFieldExpression = function () {
                var newFieldExpression = this.createNewEntity("TreeItemToTreeItemExpression");
                newFieldExpression.expressionType = 1 /* TreeItemToTreeItem */;
                return newFieldExpression;
            };
            ConditionService.prototype.createValueExpression = function () {
                var fieldToConstantExpression = this.createNewEntity("TreeItemToConstantExpression");
                fieldToConstantExpression.expressionType = 0 /* TreeItemToConstant */;
                return fieldToConstantExpression;
            };
            ConditionService.prototype.createGroupExpression = function () {
                var groupExpression = this.createNewEntity("GroupExpression");
                groupExpression.expressionType = 2 /* Group */;
                groupExpression.isAnd = false;
                return groupExpression;
            };
            ConditionService.prototype.createStepExpression = function () {
                var formStepExpression = this.createNewEntity("FormStepExpression");
                formStepExpression.expressionType = 3 /* Step */;
                return formStepExpression;
            };
            ConditionService.prototype.createOperationParameterSet = function () {
                return this.createNewEntity("OperationParameterSet");
            };
            ConditionService.prototype.createOperationParameter = function (set) {
                var param = this.createNewEntity("OperationParameter");
                param.myOperationParameterSet = set;
                return param;
            };
            ConditionService.prototype.getOperationSetExpanded = function (id) {
                var expand = "operationParameters.treeItem.schemaProperty, " +
                    "operationParameters.treeItem.calculation, " +
                    "operationParameters.treeItem.condition, " +
                    "operationParameters.treeItem.constantValue, " +
                    "operationParameters.treeItem.formStep, " +
                    "operationParameters.treeItem.claim";
                var query = this.breezeModule.EntityQuery
                    .from("OperationParameterSets")
                    .where('id', '==', id)
                    .expand(expand);
                return (this.executeQuery(query));
            };
            ConditionService.prototype.executeConditions = function (id, conditionIds) {
                var d = this.$q.defer();
                this.$http.post('./api/condition/' + id + '/ExecuteConditions/', conditionIds)
                    .then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ConditionService.prototype.executeAssignConditions = function (processId, claimUniqueId, assignUserId, assignmentRights) {
                var d = this.$q.defer();
                this.$http.post('./api/condition/ExecuteAssignConditions/' + processId + '/' + claimUniqueId + '/' + assignUserId, assignmentRights)
                    .then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ConditionService.prototype.executeUnAssigConditions = function (processId, assignmentId, assignmentRights) {
                var d = this.$q.defer();
                this.$http.post('./api/condition/ExecuteUnAssignConditions/' + processId + '/' + assignmentId, assignmentRights)
                    .then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ConditionService.prototype.executeCondition = function (id, conditionId) {
                var d = this.$q.defer();
                this.$http.post('./api/condition/' + id + '/ExecuteCondition/' + conditionId, {})
                    .then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            return ConditionService;
        }(services.DataService));
        services.ConditionService = ConditionService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ConditionService', ['breeze', '$q', '$http']);
